import React, { useMemo, useEffect, useState } from "react";
import { object, shape } from "prop-types";
import HeroBanner from "../../organisms/HeroBanner";
import EventsContentSection from "../../organisms/EventsContentSection";
import ConferencesSection from "../../organisms/ConferencesSection";
import EventsSection from "../../organisms/EventsSection";
import BecomeAMemberSection from "../../organisms/BecomeAMemberSection";
import { mapStoryToSections, mapCollectionStoryToHeroData, fetchEventsCollection } from "./events-page-mapper";

import "./events-page.m.css";
import "../../organisms/_shared/section-styles.m.css"

export const EventsPage = (props) => {
  const { data } = props;
  const [heroData, setHeroData] = useState(null);

  // Fetch events collection for hero banner
  useEffect(() => {
    const loadHeroData = async () => {
      const { heroStory, collectionData } = await fetchEventsCollection("events");
      const mappedHeroData = mapCollectionStoryToHeroData(heroStory, collectionData);
      setHeroData(mappedHeroData);
    };

    loadHeroData();
  }, []);

  // Map story data to sections using useMemo for performance
  const sectionsData = useMemo(() => {
    if (data?.story) {
      return mapStoryToSections(data.story);
    }
    return null;
  }, [data?.story]);

  const { backgroundImage = "", title = "", eventInfo = {}, buttons = [], storyUrl } = heroData || {};
  const breadcrumbs = [
    {
        "label": "Events",
        "href": "/events"
    },
  ];

  const {
    conferences = {},
    workshops = {},
    sessions = {},
  } = sectionsData || {};

  return (
    <div className="events-page" styleName="events-page">
      <HeroBanner
        backgroundImage={backgroundImage}
        breadcrumbs={breadcrumbs}
        title={title}
        eventInfo={eventInfo}
        buttons={buttons}
        storyUrl={storyUrl}
      />

      <EventsContentSection
        content={sectionsData?.eventsContent?.content}
      />
      <ConferencesSection
        tags={conferences?.tags}
        highlightText={conferences?.highlightText}
        basicCards={conferences?.basicCards}
        specialCards={conferences?.specialCards}
        highlightHeading={conferences?.heading}
        linkHref="/events/conferences"
      />
      <EventsSection
        styleName="section-container"
        tags={workshops?.tags}
        highlightText={workshops?.highlightText}
        cards={workshops?.cards}
        highlightHeading={workshops?.heading}
        eventType="workshops"
        linkHref="/events/workshops"
      />
      <EventsSection
        styleName="sessions-section section-container"
        tags={sessions?.tags}
        highlightText={sessions?.highlightText}
        cards={sessions?.cards}
        highlightHeading={sessions?.heading}
        eventType="sessions"
        linkHref="/events/sessions"
      />
      <BecomeAMemberSection becomeAMember={sectionsData?.becomeAMember} />
    </div>
  );
};

EventsPage.propTypes = {
  data: shape({
    // Future dynamic data structure
  })
};

export default EventsPage;